import {uniqBy} from 'ramda';

import {CompositionFont} from '@dms/api/sales';

/**
 * Uploaded font families sorted by name, one representative face each. The face id is a stable
 * option value: a family name can collide with a fixed option value, an id cannot.
 */
export const getFontFamilies = (fonts: CompositionFont[]) =>
  uniqBy((font) => font.family, fonts)
    .map((font) => ({family: font.family, optionValue: font.id}))
    .sort((first, second) => first.family.localeCompare(second.family));
